import { config } from '@shopee-user/platform';
import {
  GetChangePhoneContactUsLinkFunction,
  GetUserAccountChangePhoneContactUsLinkFunction,
} from '@shopee-user/business-customization-types';

const CHANGE_PHONE_CONTACT_US_LINK_MAP: Record<string, string> = {
  SG: 'https://spx.sg',
  VN: 'https://spx.vn/support-center/faq',
  TH: 'https://spx.co.th/support-center/faq',
  ID:
    'https://help.shopee.co.id/portal/article/73736-%3Cem%3EAgen%3C%2Fem%3E-%3Cem%3EShopee%3C%2Fem%3E?previousPage=search%20results%20page',
  BR: 'https://help.shopee.com.br/portal',
  PH: 'https://spx.ph/customer-service-introduction',
  MY: 'https://spx.com.my/customer-service-introduction',
};

export const getChangePhoneContactUsLink: GetChangePhoneContactUsLinkFunction = () =>
  CHANGE_PHONE_CONTACT_US_LINK_MAP[config.LOCALE as string] || '';

const USER_ACCOUNT_CHANGE_PHONE_CONTACT_US_LINK_MAP: Record<string, string> = {
  SG: 'https://seller.shopee.sg/edu/article/9326',
  VN: 'https://spx.vn/support-center/faq',
  TH: 'https://spx.co.th/support-center/faq',
  ID:
    'https://help.shopee.co.id/portal/article/73736-%3Cem%3EAgen%3C%2Fem%3E-%3Cem%3EShopee%3C%2Fem%3E?previousPage=search%20results%20page',
  BR: 'https://help.shopee.com.br/portal',
  PH: 'https://spx.ph/customer-service-introduction',
  MY: 'https://spx.com.my/customer-service-introduction',
};

export const getUserAccountChangePhoneContactUsLink: GetUserAccountChangePhoneContactUsLinkFunction = () =>
  USER_ACCOUNT_CHANGE_PHONE_CONTACT_US_LINK_MAP[config.LOCALE as string] || '';
